import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

import { FormItem } from '../../../../../../components/formReducer';
import Input from './mobile';
import ImgVCode from './imgVCode';
import MessagePin from './messagePin';
import { bindRealNameMobile, sendSms, checkSms, cacheUserInfo } from '../../../../../../services/api';
import { cookie } from '@ifeng/ui_base';

class LoginByPhone extends React.PureComponent {
    static propTypes = {};

    state = {
        fieldsValue: {},
        fieldsError: {},
        names: [],
        rules: [],
        error: '',

        imgCodeRequired: false,
        captcha_id: '',
        auth_token: '',
    };

    // 接收表单返回值
    handleChange = value => {
        const { fieldsValue } = this.state;

        fieldsValue[value.fieldsName] = value.fieldsValue;
        const newfieldsValue = JSON.parse(JSON.stringify(fieldsValue));

        this.setState({
            fieldsValue: newfieldsValue,
        });
    };

    // 接收错误信息
    handleError = error => {
        const { fieldsError } = this.state;

        fieldsError[error.fieldsName] = error.fieldsError;
        const newfieldsError = JSON.parse(JSON.stringify(fieldsError));

        this.setState({
            error,
            fieldsError: newfieldsError,
        });
    };

    // 清除指定错误信息
    clearErrors = name => {
        const { fieldsError, error } = this.state;
        const newFieldsError = JSON.parse(JSON.stringify(fieldsError));

        if (newFieldsError.hasOwnProperty(name)) {
            delete newFieldsError[name];
        }

        this.setState(
            {
                fieldsError: newFieldsError,
            },
            () => {
                if (error.fieldsName === name) {
                    this.setState({
                        error: '',
                    });
                }
            },
        );
    };

    // 收集校验规则
    selectRules = (name, itemRules) => {
        const { names, rules } = this.state;

        names.push(name);
        rules[name] = itemRules;
        this.setState({
            names,
            rules,
        });
    };

    // 执行全局校验
    runCheck = () => {
        const { rules, fieldsValue } = this.state;

        for (const name in rules) {
            if (rules.hasOwnProperty(name)) {
                const itemRules = rules[name];

                this.handleCheck(fieldsValue[name], itemRules, name);
            }
        }
    };

    // 全局错误中转
    errCallBack = (name, error) => {
        const { fieldsError, names } = this.state;

        fieldsError[name] = error;
        const newfieldsError = JSON.parse(JSON.stringify(fieldsError));

        this.setState(
            {
                fieldsError: newfieldsError,
            },
            () => {
                for (let i = 0; i < names.length; i++) {
                    const item = names[i];

                    if (newfieldsError[item]) {
                        this.setState({
                            error: {
                                fieldsName: item,
                                fieldsError: newfieldsError[item],
                            },
                        });
                        break;
                    }
                }
            },
        );
    };

    // 处理全局校验
    handleCheck = (value, rules, name) => {
        for (let i = 0; i < rules.length; i++) {
            const item = rules[i];

            // 必填项
            if (item.hasOwnProperty('required') && item.required === true) {
                if (!value) {
                    this.errCallBack(name, item.message);
                    console.warn(`fieldsError:[${name}] ===== ${item.message}`);
                    break;
                } else {
                    this.clearErrors(name);
                }
            }

            // 正则校验
            if (item.hasOwnProperty('pattern')) {
                const pattern = item.pattern;

                if (!pattern.test(value)) {
                    this.errCallBack(name, item.message);
                    console.warn(`fieldsError:[${name}] ===== ${item.message}`);
                    break;
                } else {
                    this.clearErrors(name);
                }
            }

            // 自定义检验函数
            if (item.hasOwnProperty('validator')) {
                let flag = false;
                const validator = item.validator;
                const callBack = message => {
                    if (message) {
                        this.errCallBack(name, message);
                        console.warn(`fieldsError:[${name}] ===== ${message}`);
                        flag = true;
                    } else {
                        flag = false;
                        this.clearErrors(name);
                    }
                };

                validator(value, callBack);
                if (flag) {
                    break;
                }
            }
        }
    };

    // 获取短信验证码
    getMsgPin = async callback => {
        const { fieldsValue, fieldsError } = this.state;

        if (!fieldsValue['mobile']) {
            this.handleError({
                fieldsName: 'mobile',
                fieldsError: '请填写手机号!',
            });
        } else if (fieldsError['mobile']) {
            this.handleError({
                fieldsName: 'mobile',
                fieldsError: fieldsError['mobile'],
            });
        } else {
            // eslint-disable-next-line no-lonely-if
            if (!this.state.imgCodeRequired) {
                const res = await sendSms(
                    {
                        mobile: fieldsValue['mobile'],
                        smsform: 1,
                    },
                    this.showImgCode,
                    this.getImgCodeFall,
                );

                if (this.state.imgCodeRequired) {
                    return;
                } else if (!res) {
                    return;
                }

                callback();
            } else if (this.state.imgCodeRequired) {
                const res = await sendSms(
                    {
                        mobile: fieldsValue['mobile'],
                        smsform: 1,
                        captcha_code: fieldsValue['captcha_code'],
                        captcha_id: this.state.captcha_id,
                    },
                    this.showImgCode,
                    this.getImgCodeFall,
                );

                callback();
            }
        }
    };

    getImgCodeFall = (code, tip) => {
        if (code === 'Unkown') {
            this.handleError({
                fieldsName: 'smscode',
                fieldsError: '未知错误，请更换手机号重试',
            });
        } else if (
            [
                'SendSMSTooManyPerMinute',
                'SendSMSTooManyPerHour',
                'SendSMSTooManyPerDay',
                'SendSMSTooManyPerYear',
                'SendSMSTooManyPerMonth',
                'IPNotInMainland',
            ].includes(code)
        ) {
            this.handleError('captcha_code', {
                fieldsName: 'smscode',
                fieldsError: tip,
            });
        } else {
            alert(tip);
        }
        if (this.state.imgCodeRequired) {
            this.refreshVCode();
        }
    };

    showImgCode = () => {
        this.setState({
            imgCodeRequired: true,
        });
    };

    refreshVCode = null;

    bindGetCode = cb => {
        this.refreshVCode = cb;
    };

    getImgCodeId = captcha_id => {
        this.setState({
            captcha_id,
        });
    };

    // 提交登录
    handleSubmmit = e => {
        this.runCheck();

        const { fieldsValue, fieldsError } = this.state;

        console.log(fieldsValue, fieldsError);
        if (!fieldsError || !Object.keys(fieldsError).length) {
            const { mobile, smscode } = fieldsValue;
            const params = { realname_mobile: mobile, smscode };

            console.log(params);
            this.asyncBindPost(params);
        }
    };

    // 检验手机验证码
    asyncCheckSms = async params => {
        const res = await checkSms(params, this.checkSmsFail);

        if (res && res.authtoken) {
            return res.authtoken;
        }
    };

    // 校验手机验证码失败
    checkSmsFail = (code, tips) => {
        if (code === 'IllegalMobile') {
            this.handleError({
                fieldsName: 'mobile',
                fieldsError: tips,
            });
        } else {
            this.handleError({
                fieldsName: 'smscode',
                fieldsError: tips,
            });
            // this.setState({

            //     error: {
            //         fieldsName: 'smscode',
            //         fieldsError: tips,
            //     },
            // });
        }
    };

    LOGINTIMER = null;

    // 登录请求
    asyncBindPost = async params => {
        // const { mobile, smscode } = params;

        // const auth_token = await this.asyncCheckSms(params);

        // console.log(auth_token);
        // const newParams = {
        //     mobile,
        //     sms: smscode,
        //     auth_token,
        // };

        const res = await bindRealNameMobile(params, this.bindMobileFaild);

        console.log(res);
        if (res === null) {
            this.setState({
                error: {},
            });

            // clearInterval(this.LOGINTIMER);
            // this.LOGINTIMER = setInterval(() => {
            //     const sid = cookie.get('sid');

            //     if (sid) {
            //         console.log(sid);

            //         clearInterval(this.LOGINTIMER);
            //         cacheUserInfo();
            //     }
            // }, 100);
        }
    };

    bindMobileFaild = (code, tips) => {
        if (
            code === 'MobileAlreadyExists' ||
            code === 'AccountNotFound' ||
            code === 'IllegalMobile' ||
            code === 'InvalidParamter' ||
            code === 'InvalidParamter'
        ) {
            this.handleError({
                fieldsName: 'mobile',
                fieldsError: tips,
            });
        } else {
            this.handleError({
                fieldsName: 'smscode',
                fieldsError: tips,
            });
        }
        if (this.state.imgCodeRequired) {
            this.refreshVCode();
        }
    };

    render() {
        const { fieldsError, imgCodeRequired } = this.state;
        const config = {
            onChange: this.handleChange,
            onBlur: this.handleChange,
            onError: this.handleError,
            clearErrors: this.clearErrors,
            callbackRules: this.selectRules,
            fieldsError,
        };

        return (
            <div className={styles.loginByPhone}>
                <FormItem
                    {...config}
                    name={'mobile'}
                    validateTrigger={'blur'}
                    rules={[
                        {
                            required: true,
                            message: '请填写手机号!',
                        },
                        {
                            pattern: /^1\d{10}$/,
                            message: '请填写正确的手机号!',
                        },
                    ]}>
                    <Input placeholder={'手机号'} style={{ marginBottom: 14 }} onKeydown={this.handleSubmmit} />
                </FormItem>
                {imgCodeRequired ? (
                    <FormItem
                        {...config}
                        name={'captcha_code'}
                        validateTrigger={'blur'}
                        rules={[
                            {
                                required: true,
                                message: '请填写验证码!',
                            },
                        ]}>
                        <ImgVCode
                            bindGetCode={this.bindGetCode}
                            getImgCodeId={this.getImgCodeId}
                            onKeydown={this.handleSubmmit}
                        />
                    </FormItem>
                ) : null}

                <FormItem
                    {...config}
                    name={'smscode'}
                    validateTrigger={'blur'}
                    rules={[
                        {
                            required: true,
                            message: '请填写短信验证码!',
                        },
                    ]}>
                    <MessagePin getCode={this.getMsgPin} onKeydown={this.handleSubmmit} />
                </FormItem>

                <div className={styles.submmitBtn} onClick={this.handleSubmmit}>
                    确定
                </div>
            </div>
        );
    }
}

export default errorBoundary(LoginByPhone);
